import { createBrowserClient } from '@supabase/ssr';

/**
 * Returns a Supabase client configured for browser-side usage.
 * Used exclusively for authentication flows (signIn, signUp, OAuth, session).
 * All database access goes through server functions with Prisma.
 */
export function getSupabaseBrowserClient() {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    throw new Error(
      'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set',
    );
  }

  return createBrowserClient(url, anonKey);
}
